exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".margin-left-right-10 {\n  margin-right: 10;\n  margin-left: 10;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /usr/src/app/src/app/modules/constructs/constructs-overview/constructs-overview.component.css
// module id = ../../../../../src/app/modules/constructs/constructs-overview/constructs-overview.component.css
// module chunks = main